<template>
  <div id="page-back-edit-tendering-message">
    <div class="clear-fix">
      <div class="el-col content left">
        <el-scrollbar :native="false" style="height: 100%;">
          <h3 class="title">更新设置</h3>
          <div class="btn-group">
            <el-button icon="el-icon-delete-solid" type="danger" @click="del">删除</el-button>
            <el-button class="right" icon="el-icon-upload" type="primary" @click="saveTenderingMessage()">
              保存
            </el-button>
          </div>

          <div class="save-wrap">
            <el-alert :closable="false" center class="left" show-icon title="双击要编辑的单元格进行编辑，编辑完成记得保存哦"
              type="warning"></el-alert>
          </div>
          <div class="grid-content update-area">
            <el-table ref="singleTable" :data="tableData" :row-class-name="tableRowClassName" border highlight-current-row
              style="width: 99%;margin: 0 auto;" @cell-dblclick="cellEdit">
              <el-table-column type="index"></el-table-column>
              <el-table-column label="项目名称" prop="title" width="160"></el-table-column>
              <el-table-column label="项目内容" prop="content">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.type === 1 && scope.row.content.edit" ref="content"
                    v-model="scope.row.content.value" autosize style="width: 100%" type="textarea"
                    @blur="scope.row.content.edit = false"></el-input>
                  <el-date-picker v-else-if="scope.row.type === 2 && scope.row.content.edit" ref="content"
                    v-model="scope.row.content.value" default-time="01:00:00" style="width: 100%" type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss" @blur="scope.row.content.edit = false"></el-date-picker>
                  <el-select v-else-if="scope.row.type === 3 && scope.row.content.edit" ref="content"
                    v-model="scope.row.content.value" clearable filterable placeholder="请选择"
                    @change="regionChange(scope.row.content.value, scope.row.propertyName)">
                    <el-option v-for="item in scope.row.options" :key="item.key" :label="item.value" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input v-else-if="scope.row.type === 5 && scope.row.content.edit" ref="content"
                    v-model="scope.row.content.value" :min="0" style="width: 200px;" type="number"
                    @blur="numBlur(scope.$index, scope.row.content.value)">
                  </el-input>
                  <div v-else-if="scope.row.type === 6">
                    <div v-for="item in scope.row.content.value" :key="item.id">
                      <el-link v-if="item.fileName" :href="item.fileName" download type="primary">
                        {{ item.attachmentName }}
                      </el-link>
                    </div>
                  </div>
                  <div v-else-if="scope.row.type === 7">{{ scope.row.content.value }}</div>
                  <span v-else>{{ scope.row.content.value }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="save-wrap">
            <el-alert :closable="false" center class="left" show-icon title="编辑完成一定记得保存哦" type="warning" />
            <!--<el-button class="right" icon="el-icon-upload" type="primary" @click="saveTenderingMessage()">-->
            <!--  保存-->
            <!--</el-button>-->
          </div>
        </el-scrollbar>

      </div>
      <div class="el-col content right">
        <el-scrollbar :native="false" :wrapStyle="wrapStyle" style="height: 100%;">
          <div class="title-box">
            <h3 class="title">公告原文</h3><a :href="aUrl" target="_blank">查看原文</a>
          </div>
          <div v-if="tenderingMessageInfo.content" class="grid-content origin-content"
            v-html="utils.htmlRestore(tenderingMessageInfo.content)"></div>
        </el-scrollbar>
      </div>
    </div>

    <el-dialog :before-close="closeAddTag" :visible.sync="dialogAddVisible" title="添加品目" width="50%">
      <el-form :model="addTagForm" style="width: 49%;float: left;">
        <el-form-item label="编码" label-width="100px">
          <el-input v-model="addTagForm.code" autocomplete="off" disabled style="width: 188px;"></el-input>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 1" label="一级标签" label-width="100px">
          <el-select v-model="addTagForm.level_1" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 1)">
            <el-option v-for="item in level_1" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 2" label="二级标签" label-width="100px">
          <el-select v-model="addTagForm.level_2" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 2)">
            <el-option v-for="item in level_2" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 3" label="三级标签" label-width="100px">
          <el-select v-model="addTagForm.level_3" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 3)">
            <el-option v-for="item in level_3" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 4" label="四级标签" label-width="100px">
          <el-select v-model="addTagForm.level_4" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 4)">
            <el-option v-for="item in level_4" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 5" label="五级标签" label-width="100px">
          <el-select v-model="addTagForm.level_5" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 5)">
            <el-option v-for="item in level_5" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 6" label="六级标签" label-width="100px">
          <el-select v-model="addTagForm.level_6" default-first-option filterable placeholder="请选择"
            @change="addTagChange($event, 6)">
            <el-option v-for="item in level_6" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form style="width: 49%;float: right;">
        <el-tag v-for="(tag, index) in addTagList" :key="tag.code" :disable-transitions="false" closable
          @close="handleClose(index)">
          {{ tag.name }}
        </el-tag>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddTag">添加</el-button>
        <el-button type="primary" @click="confirmSaveAdd">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "backEditTenderingMessage",
  data() {
    return {
      tableData: [],
      tenderingMessageId: '',
      tenderingMessageInfo: {},
      wrapStyle: {
        fontSize: '30px'
      },
      regionProvinceList: [],
      regionCityList: [],
      regionTownList: [],
      dialogAddVisible: false,
      level_1: [],
      level_2: [],
      level_3: [],
      level_4: [],
      level_5: [],
      level_6: [],
      addTagName: '',
      addTagCodeLength: 1,
      addTagForm: {
        levelSelectShow: 1,
        code: '',
        level_1: '',
        level_2: '',
        level_3: '',
        level_4: '',
        level_5: '',
        level_6: '',
        generalTerm: ['近义词', '同义词']
      },
      addTagList: [],
      aUrl: '',
    }
  },
  created() {
    let loading = this.$loading(this.utils.defaultLoadingOptions);
    this.tenderingMessageId = this.$route.query.id;
    this.$request.tenderingMessageInfo({
      id: this.tenderingMessageId
    }).then(res => {
      loading.close()
      if (res.status == 200) {
        let resData = res.data;
        this.tenderingMessageInfo = resData;
        this.aUrl = resData.pageUrl

        //请求默认省市县数据
        this.$request.searchRegion().then(res2 => {
          console.log(res2);
          if (res2.status == 200) {
            res2.data.forEach((item) => {
              this.regionProvinceList.push(item);
              if (item.value == resData.province) {
                this.$request.searchRegion({
                  level: 2,
                  parentCode: item.key
                }).then(res3 => {
                  if (res3.status == 200) {
                    res3.data.forEach(item2 => {
                      this.regionCityList.push(item2);
                      if (item2.value == resData.city) {
                        this.$request.searchRegion({
                          level: 3,
                          parentCode: item2.key
                        }).then(res4 => {
                          if (res4.status == 200) {
                            res4.data.forEach(item3 => {
                              this.regionTownList.push(item3)
                            })
                          } else {
                            this.requestError(res4.status, res4.message)
                          }

                        }, err => {
                          console.log(err);
                          this.requestFail(err);
                        })
                      }
                    })
                  } else {
                    this.requestError(res3.status, res3.message)
                  }
                }, err => {
                  console.log(err)
                  this.requestFail(err);
                })
              }
            });

          } else {
            this.requestError(res2.status, res2.message)
          }
        }, err => {
          console.log(err)
          loading.close();
          this.requestFail(err);
        })

        //格式化表格为所需要数据
        // type:1、字符串 2、日期 3、单选 4、多选 5、数字 6、附件 7、标准库（双击不修改）
        this.tableData = [
          {
            type: 1,
            propertyName: 'title',
            title: '标讯标题',
            content: {
              edit: false,
              value: resData.title
            },
          },
          {
            type: 1,
            propertyName: 'projectName',
            title: '项目名称',
            content: {
              edit: false,
              value: resData.projectName
            }
          },
          {
            type: 1,
            propertyName: 'projectCode',
            title: '项目编号',
            content: {
              edit: false,
              value: resData.projectCode
            }
          },
          {
            type: 2,
            propertyName: 'projectDate',
            title: '公告日期',
            content: {
              edit: false,
              value: resData.projectDate
            }
          },
          {
            type: 1,
            propertyName: 'expert',
            title: '评标专家',
            content: {
              edit: false,
              value: resData.expert
            }
          },
          {
            type: 1,
            propertyName: 'projectIntro',
            title: '项目简介',
            content: {
              edit: false,
              value: resData.projectIntro
            }
          },
          {
            type: 5,
            propertyName: 'bidMoney',
            title: '中标金额（元）',
            content: {
              edit: false,
              value: resData.bidMoney ? (parseInt(resData.bidMoney) / 100).toFixed(2) : resData.bidMoney
            }
          },
          {
            type: 5,
            propertyName: 'budgetMoney',
            title: '预算金额（元）',
            content: {
              edit: false,
              value: resData.budgetMoney ? (parseInt(resData.budgetMoney) / 100).toFixed(2) : resData.budgetMoney
            }
          },
          {
            type: 1,
            propertyName: 'item',
            title: '品目',
            content: {
              edit: false,
              value: (() => {
                let itemStr = '';
                if (resData.bidItems && resData.bidItems.length) {
                  resData.bidItems.forEach(item => {
                    itemStr += item.item1Name + '、';
                    this.addTagList.push({
                      name: item.item1Name,
                      code: item.item1Code
                    })
                  })
                }
                return itemStr ? itemStr.substr(0, itemStr.length - 1) : '';
              })()
            }
          },
          {
            type: 3,
            propertyName: 'province',
            title: '省',
            content: {
              edit: false,
              value: resData.province
            },
            options: this.regionProvinceList
          },
          {
            type: 3,
            propertyName: 'city',
            title: '市',
            content: {
              edit: false,
              value: resData.city
            },
            options: this.regionCityList
          },
          {
            type: 3,
            propertyName: 'town',
            title: '县',
            content: {
              edit: false,
              value: resData.town
            },
            options: this.regionTownList
          },
          {
            type: 3,
            propertyName: 'subcontract',
            title: '分包情况',
            content: {
              edit: false,
              value: resData.subcontract
            },
            options: [
              {
                id: 1,
                value: '已分包'
              },
              {
                id: 2,
                value: '未分包'
              }
            ]
          },
          {
            type: 1,
            propertyName: 'companyName',
            title: '采购单位',
            content: {
              edit: false,
              value: resData.companyName
            }
          },
          {
            type: 7,
            propertyName: 'companyStandardName',
            title: '采购人标准名称',
            content: {
              edit: false,
              value: resData.companyStandardName
            }
          },
          {
            type: 1,
            propertyName: 'companyContact',
            title: '采购单位联系人',
            content: {
              edit: false,
              value: resData.companyContact
            }
          },
          {
            type: 1,
            propertyName: 'companyAddress',
            title: '采购单位地址',
            content: {
              edit: false,
              value: resData.companyAddress
            }
          },
          {
            type: 1,
            propertyName: 'companyTel',
            title: '采购单位电话',
            content: {
              edit: false,
              value: resData.companyTel
            }
          },
          {
            type: 1,
            propertyName: 'agencyName',
            title: '代理机构',
            content: {
              edit: false,
              value: resData.agencyName
            }
          },
          {
            type: 7,
            propertyName: 'agencyStandardName',
            title: '代理机构标准名称',
            content: {
              edit: false,
              value: resData.agencyStandardName
            }
          },
          {
            type: 1,
            propertyName: 'agencyContact',
            title: '代理机构联系人',
            content: {
              edit: false,
              value: resData.agencyContact
            }
          },
          {
            type: 1,
            propertyName: 'agencyAddress',
            title: '代理机构地址',
            content: {
              edit: false,
              value: resData.agencyAddress
            }
          },
          {
            type: 1,
            propertyName: 'agencyTel',
            title: '代理机构电话',
            content: {
              edit: false,
              value: resData.agencyTel
            }
          },
          {
            type: 3,
            propertyName: 'announcementTypeName',
            title: '公告类型',
            content: {
              edit: false,
              value: resData.announcementTypeName
            },
            options: (() => {
              let returnData = [];
              this.$request.searchAnnouncement().then(res => {
                console.log(res);
                if (res.status == 200) {
                  res.data.forEach(item => {
                    returnData.push(item)
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
                this.requestFail(err);
              })

              return returnData
            })()
          },
          {
            type: 3,
            propertyName: 'purchaseTypeName',
            title: '采购方式',
            content: {
              edit: false,
              value: resData.purchaseTypeName
            },
            options: (() => {
              let returnData = [];
              this.$request.searchPurchase().then(res => {
                console.log(res);
                if (res.status == 200) {
                  res.data.forEach(item => {
                    returnData.push(item)
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
                this.requestFail(err);
              })

              return returnData
            })()
          },
          {
            type: 3,
            propertyName: 'purchaserName',
            title: '采购人类型',
            content: {
              edit: false,
              value: resData.purchaserName
            },
            options: (() => {
              let returnData = [];
              this.$request.searchPurchaser().then(res => {
                console.log(res);
                if (res.status == 200) {
                  res.data.forEach(item => {
                    returnData.push(item)
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err);
                this.requestFail(err);
              })
              // console.log(returnData)
              return returnData
            })()
          },
          {
            type: 1,
            propertyName: 'winningBidder',
            title: '供应商',
            content: {
              edit: false,
              value: resData.winningBidder
            }
          },
          {
            type: 7,
            propertyName: 'winningBidderStandardAnalyzer',
            title: '供应商标准名称',
            content: {
              edit: false,
              value: resData.winningBidderStandardAnalyzer?.slice(0, -1)
            }
          },
          {
            type: 1,
            propertyName: 'brand',
            title: '品牌',
            content: {
              edit: false,
              value: resData.brand
            }
          },
          {
            type: 1,
            propertyName: 'productType',
            title: '产品类型',
            content: {
              edit: false,
              value: resData.productType
            }
          },
          {
            type: 1,
            propertyName: 'marketSegments',
            title: '细分市场',
            content: {
              edit: false,
              value: resData.marketSegments
            }
          },
          {
            type: 1,
            propertyName: 'getBidDocTime',
            title: '获取招标文件时间',
            content: {
              edit: false,
              value: resData.getBidDocTime
            }
          },
          {
            type: 1,
            propertyName: 'getBidDocAddress',
            title: '获取招标文件地点',
            content: {
              edit: false,
              value: resData.getBidDocAddress
            }
          },
          {
            type: 2,
            propertyName: 'bidOpeningTime',
            title: '开标时间',
            content: {
              edit: false,
              value: resData.bidOpeningTime
            }
          },
          {
            type: 1,
            propertyName: 'bidOpeningAddress',
            title: '开标地点',
            content: {
              edit: false,
              value: resData.bidOpeningAddress
            }
          },
          {
            type: 2,
            propertyName: 'bidEndTime',
            title: '投标截止日期',
            content: {
              edit: false,
              value: resData.bidEndTime
            }
          },
          {
            type: 2,
            propertyName: 'estimatedPurchaseTime',
            title: '预计采购时间',
            content: {
              edit: false,
              value: resData.estimatedPurchaseTime
            }
          },
          {
            type: 1,
            propertyName: 'intentionOfProject',
            title: '项目所在采购意向',
            content: {
              edit: false,
              value: resData.intentionOfProject
            }
          },
          {
            type: 2,
            propertyName: 'winDate',
            title: '中标日期',
            content: {
              edit: false,
              value: resData.winDate
            }
          },
          {
            type: 2,
            propertyName: 'changeDate',
            title: '标讯更正日期',
            content: {
              edit: false,
              value: resData.changeDate
            }
          },
          {
            type: 6,
            propertyName: 'esBidAttachmentList',
            title: '附件',
            content: {
              edit: false,
              value: resData?.esBidAttachmentList || []
            }
          }
        ];
        this.setCurrent()
      } else {
        if (res.message === '未找到该标讯详情') {
          this.$confirm(`${res.message}, 是否恢复数据到MySQL?`, '提示', {
            confirmButtonText: '恢复',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let res = await this.$request.restoreToDB(this.tenderingMessageId)
            if (res.status == 200) {
              location.reload()
            } else {
              this.requestError(res.status, res.message)
            }
          }).catch(() => null);
          return
        }
        this.requestError(res.status, res.message)
      }
    }, err => {
      console.log(err)
    })
  },
  methods: {
    tableRowClassName(val) {
      if (val.row.type == 7) {
        console.log(111111111111, val.row)
        return 'row-disable'
      }
    },
    setCurrent() {
      for (const key in this.tableData) {
        const item = this.tableData[key]
        if (this.$route.query.select === item.propertyName) {
          this.$refs.singleTable.setCurrentRow(item);
          console.log(item)
        }
      }

    },
    handleClose(index) {//删除已添加品目
      console.log(index)
      this.addTagList.splice(index, 1);
    },
    addNewTag() {//点击添加标签
      this.$request.listItemChildren().then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.level_1 = res.data;
          this.dialogAddVisible = true;
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },
    closeAddTag() {
      this.dialogAddVisible = false;
    },
    addTagChange(val, level) {
      console.log(val, level);
      this['level_' + level].forEach(item => {
        if (val == item.code) {
          this.addTagName = item.name
        }
      });
      this.addTagForm.code = val;
      this.addTagForm.levelSelectShow = level + 1;
      this.$request.listItemChildren({
        code: val
      }).then(res => {
        // console.log(res);
        if (res.status == 200) {
          this['level_' + (level + 1)] = res.data;

          for (let i = level; i < 6; i++) {
            if (this['level_' + (i + 2)] && this['level_' + (i + 2)].length > 0) {
              this['level_' + (i + 2)] = [];
            }
            this.addTagForm['level_' + (i + 1)] = '';
            // console.log(this.addTagForm)
          }
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },

    // 金额 失焦
    numBlur(index, value) {
      if (+value) {
        this.tableData[index].content.value = +(+value).toFixed(2)
      } else {
        this.tableData[index].content.value = 0
      }
      console.log(this.tableData[index].content.value)
    },
    confirmSaveAdd() {
      this.tableData.forEach((item) => {
        if (item.propertyName == 'item') {
          let itemStr = '';
          this.addTagList.forEach(item => {
            itemStr += item.name + '、';
          });
          item.content.value = itemStr.substring(0, itemStr.length - 1);
        }
      })
      this.dialogAddVisible = false;
    },
    confirmAddTag() {
      if (this.addTagForm.code.length > 1) {
        if (!this.addTagList.some(item => {
          return item.code === this.addTagForm.code
        }, this)) {
          this.addTagList.push({
            code: this.addTagForm.code,
            name: this.addTagName
          })
        } else {
          this.$message({
            type: 'warning',
            message: '已经添加过该品目了！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请选择！'
        })
      }
    },
    regionChange(value, level) {//地区选择改变时触发
      // console.log(value,level)
      if (level == 'province') {
        // console.log(value,this.regionProvinceList)
        if (value == '') {
          this.tableData.forEach((item) => {
            if (item.propertyName == 'city') {
              item.content.value = '';
              item.options = [];
            } else if (item.propertyName == 'town') {
              item.content.value = '';
              item.options = [];
            }
          })
        } else {
          this.regionProvinceList.forEach((item) => {
            if (value == item.value) {
              console.log(item.id);
              this.$request.searchRegion({
                level: 2,
                parentCode: item.key
              }).then(res => {
                console.log(res)
                if (res.status == 200) {
                  this.regionCityList = res.data;
                  this.tableData.forEach((item) => {
                    if (item.propertyName == 'city') {
                      item.content.value = '';
                      item.options = res.data;
                    } else if (item.propertyName == 'town') {
                      item.content.value = '';
                      item.options = [];
                    }
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
              })

            }
          })
        }

      } else if (level == 'city') {
        console.log(value);
        if (value == '') {
          this.tableData.forEach((item) => {
            if (item.propertyName == 'town') {
              item.content.value = '';
              item.options = [];
            }
          })
        } else {
          this.regionCityList.forEach((item) => {
            if (value == item.value) {
              console.log(item.key);
              this.$request.searchRegion({
                level: 3,
                parentCode: item.key
              }).then(res => {
                console.log(res);
                if (res.status == 200) {
                  this.regionTownList = res.data;
                  this.tableData.forEach((item) => {
                    if (item.propertyName == 'town') {
                      item.content.value = '';
                      item.options = res.data;
                    }
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
              })

            }
          })
        }

      }
    },
    del() {
      this.$confirm('<strong style="font-size:15px;">此操作将从数据库中删除数据【数据无法恢复】！<br> 是否继续删除?</strong>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$request.deleteTenderingMessage({ id: this.tenderingMessageId }).then(res => {
          if (res.status == 200) {
            this.$message.success('删除成功!')
            setTimeout(() => {
              window.opener = null;
              window.open('', '_self');
              window.close();
            }, 500)
          } else {
            this.$message.info('删除失败！')
          }
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    formatData() {
      this.tableData.forEach(item => {
        for (let key in item) {
          item[key] = {
            value: item[key],
            edit: false
          }
        }
      })
      console.log(this.tableData)
    },
    cellEdit(row, column, cell, event) {
      if (row.type === 7) return
      if (row.propertyName == 'item') {
        this.addNewTag();
        this.dialogAddVisible = true;
      }
      if (column.property == 'content') {
        row[column.property].edit = true;
        setTimeout(() => {
          this.$refs[column.property].focus()
        }, 20)
      }
    },
    saveTenderingMessage() {//储存修改的信息
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      let data = {
        id: this.tenderingMessageInfo.id
      };
      this.tableData.forEach((item) => {
        if (item.propertyName == 'bidMoney' || item.propertyName == 'budgetMoney') {
          data[item.propertyName] = +(item.content.value * 100).toFixed(0)
        } else if (item.propertyName == 'item') {
          let itemCodes = [];
          this.addTagList.forEach(item => {
            itemCodes.push(item.code);
          })
          data.itemCodes = itemCodes;
        } else {
          data[item.propertyName] = item.content.value;
        }
      })
      // console.log(data)

      this.$request.updateTenderingMessage(
        data
      ).then(res => {
        console.log(res)
        loading.close();
        if (res.status == 200) {
          if (res.data == 1) {
            this.$message({
              type: 'success',
              message: '保存成功！'
            });
          } else {
            this.$message({
              type: 'warning',
              message: '保存失败！'
            });
          }
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        loading.close();
        this.requestFail(err);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.btn-group {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
}

/deep/ .el-table .row-disable {
  background: #F5F7FA;
}

#page-back-edit-tendering-message {
  .height();
  padding: 20px;
  min-width: 1300px;
  background-color: #E6E6E6;
  /*height: auto !important;*/
  /*min-height: 100%;*/

  &>div {
    height: 100%;
  }

  .el-col.content {
    width: 49.8%;
    height: 100%;
    overflow: hidden;
    background-color: #FFF;
    .box-shadow();
    .border-radius(5px);

    .title-box {
      position: relative;

      a {
        position: absolute;
        right: 50px;
        top: 50%;
        transform: translateY(-50%);

      }
    }

    h3.title {
      font-size: 20px;
      text-align: center;
      margin: 20px;
    }

    .save-wrap {
      width: 100%;
      padding-right: 5px;

      .el-alert {
        //width: 90%;
        min-width: 610px;
      }

      .el-button {
        width: 10%;
        min-width: 80px;
      }
    }

    .origin-content {
      padding: 20px;
    }

    table {
      width: 100%;

      .row-title {
        width: 20%;
        line-height: 50px;
        text-align: center;
        background-color: #EEF1F6;

        &.row-content {
          width: 80%;
        }
      }

      .item-title {
        /*min-width: 20%;*/
        line-height: 50px;
        background-color: #EEF1F6;
      }

      .item-content {
        /*max-width: 80%;*/
        line-height: 50px;
        word-break: break-all;
      }
    }

    .left {
      position: relative;
    }
  }

}
</style>
<style lang="less">
#page-back-edit-tendering-message {
  .el-dialog {
    .el-dialog__body {
      .clearfix;
    }

    .el-tag {
      margin-left: 10px;
    }
  }
}
</style>